import {
  Button,
  DatePicker,
  Modal,
  Select,
  Skeleton,
  Spin,
  Switch,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { dispatchtoast, trimString } from "../../../Utils";
import {
  getFundRequestDetails,
  getFundRequestStatusUpdate,
  getFunReqestReport,
  getmemberFilterList,
} from "../../../ApiServices/Apifun";
import dayjs from "dayjs";
import ReportDrawer from "../../../Common/ReportDrawer";
import { AiOutlineSearch } from "react-icons/ai";
import Content from "../../../Common/ReceiptContent";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch, useSelector } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa6";
import ExportButton from "../../../Common/CommonExport";
import { APIURL } from "../../../ApiServices/Axios";
import { Globalendpoints } from "../../../ApiServices/global";
import CommonAmountPage from "../../../Common/CommonAmountPage";

const FundRequestReport = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [totalAmt, setTotalAmt] = useState();
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [openImageModal, SetOpenImageModal] = useState(false);
  const [attachment, setAttachment] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [memberTypeFilter, setMemberTypeFilter] = useState(null);
  const [memberOptions, setMemberOptions] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const navigate = useNavigate();
  const [amountData, setAmountData] = useState({});

  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => <p className="font-medium w-[120px]">{text}</p>,
    },
    {
      title: "Transaction Date",
      dataIndex: "cheque_date",
      key: "cheque_date",
      render: (text) => <p className="font-medium w-[120px]">{text}</p>,
    },
    {
      title: "Member Mobile",
      dataIndex: "member_mobile",
      key: "member_mobile",
      render: (text) => <p className="w-[200px]">{text}</p>,
    },
    {
      title: "Mamber Id",
      dataIndex: "member_id",
      key: "member_id",
      render: (text) => {
        return (
          <>
            <p className="w-[100px] font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Establishment",
      dataIndex: "establishment",
      key: "establishment",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text ? text : "-"}
        </p>
      ),
    },
    {
      title: "To Bank",
      dataIndex: "to_bank",
      key: "to_bank",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text ? text : "-"}
        </p>
      ),
    },
    {
      title: "Payment Mode",
      dataIndex: "payment_mode",
      key: "payment_mode",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Cheque/DD Number",
      dataIndex: "cheque_or_dd_no",
      key: "cheque_or_dd_no",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Attachment",
      dataIndex: "attachment",
      key: "attachment",
      render: (text) => (
        <img
          onClick={() => {
            setAttachment(
              text.includes("localhost")
                ? text.replace("localhost", "192.168.1.147")
                : text,
            );
            SetOpenImageModal(true);
          }}
          style={{ width: "50px", height: "50px" }}
          src={
            text.includes("localhost")
              ? text.replace("localhost", "192.168.1.147")
              : text
          }
          className="rounded-full"
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return (
          <>
            {text === "1" ? (
              <Tag color="green">Approved</Tag>
            ) : text === "2" ? (
              <Tag color="red">Rejected</Tag>
            ) : text === "3" ? (
              <Tag color="yellow">Initiated</Tag>
            ) : (
              <p
                onClick={(val) => {
                  if (record?.id) {
                    const formdata = new FormData();
                    formdata.append("id", record?.id);
                    getFundRequestDetails(formdata)
                      .then((res) => {
                        if (res.status) {
                          navigate("/fundRequest", {
                            state: {
                              record: record,
                            },
                          });
                        } else {
                          dispatchtoast("Unauthorized Access", true);
                          console.log("unauthorised access");
                        }
                      })
                      .catch((err) => console.log(err));
                  }
                }}
                className="font-medium text-xs cursor-pointer bg-rgbaprimary9 hover:bg-rgbaprimary7 text-white px-2 py-1 rounded-md text-[15px] mb-2"
              >
                Re-Initiate
              </p>
            )}
          </>
        );
      },
    },
    //  {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   render: (text) => {
    //     return (
    //       <>
    //         {text === "1" ? (
    //           <Tag color="green">Approved</Tag>
    //         ) : text === "2" ? (
    //           <Tag color="red">Rejected</Tag>
    //         ) : (
    //           <Tag color="yellow">Pending</Tag>
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text} Rs.
        </p>
      ),
    },
    {
      title: "Admin Remark",
      dataIndex: "admin_remark",
      key: "admin_remark",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text ? trimString(text) : "-"}
        </p>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[150px] overflow-y-scroll">
                {text ? trimString(text) : "-"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "View Receipt",
      dataIndex: "view",
      key: "view",
      render: (text, record) => {
        return (
          <div
            className="border border-gray-300 p-2 flex justify-center items-center rounded-md cursor-pointer"
            onClick={() => {
              setResult({
                data: {
                  Date: record.Date,
                  "Member Mobile": record.member_mobile,
                  "Cheque/DD Number": record.cheque_or_dd_no,
                  "Member Id": record.member_id,
                  "To Bank": record.to_bank,
                  "Payment Mode": record.payment_mode,
                  Amount: record.amount,
                  "Admin Remark": record.admin_remark,
                  Remark: record.remark,
                },
                transaction_id: record.transaction_id,
              });
              setOpenReceiptDrawer(true);
            }}
          >
            <FaEye />
          </div>
        );
      },
    },
  ];
  const getMemberFilter = () => {
    getmemberFilterList()
      .then((res) =>
        setMemberOptions(
          res.data.map((i, index) => {
            return {
              label: i.display_text,
              mobile: i.mobile,
              value: i.id,
              key: i.id,
            };
          }),
        ),
      )
      .catch((err) => console.log(err));
  };
  const getReport = (
    search_keyword = searchKeyword,
    search_column = searchcolumn,
    filter_member_id = memberTypeFilter ?? "",
    from_date = fromDate,
    to_date = toDate,
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: search_keyword,
      search_column: search_column,
      filter_member_id: filter_member_id,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getFunReqestReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setAmountData(res);
        setTotalAmt(res.total_amount);
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          }),
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getReport();
  }, [current, pageSize, memberTypeFilter]);
  useEffect(() => {
    dispatch(setselectedTab("11.10"));
    profiledetail.member_type !== "Retailer" && getMemberFilter();
  }, []);
  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">Fund Request Report</p>
            <div className="flex gap-2">
              <ExportButton
                endpoint={APIURL + Globalendpoints.fundRequestReport}
                fileName="fundRequestReport.xlsx"
                pageSize={pageSize}
                currentPage={current}
              />
              <p
                onClick={() => {
                  getReport("", "", "", "");
                  setSearchKeyWord("");
                  setSearchColumn(null);
                  setMemberTypeFilter(null);
                  setFromDate("");
                  setToDate("");
                }}
                className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
              >
                Clear Filter
              </p>
            </div>
          </div>
          <div
            className={`selectionFields grid grid-cols-1 gap-4 place-items-center 
  ${
    profiledetail.member_type !== "Retailer"
      ? "md:grid-cols-4"
      : "md:grid-cols-3"
  }
`}
          >
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              {searchcolumn === "fund_requests.created_at" ? (
                <>
                  <p className="required text-textGray mt-2">Keyword</p>
                  <DatePicker
                    // value={dayjs("2023-09-07","YYYY-MM-DD")}
                    popupClassName="bottom-calendar"
                    allowClear
                    // value={searchKeyword}
                    className="w-full datepicker mt-2"
                    onChange={(val) =>
                      setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                    }
                    placement="bottomLeft"
                    placeholder="Search"
                  />
                </>
              ) : searchcolumn === "fund_requests.status" ? (
                <>
                  <p className="required text-textGray mt-2">
                    Select Status Type
                  </p>
                  <Select
                    placeholder="Select Status type"
                    value={searchKeyword}
                    onChange={(val) => setSearchKeyWord(val)}
                    className="w-full mt-2"
                    options={[
                      { label: "Pending", value: "0" },
                      { label: "Approved", value: "1" },
                      { label: "Rejected", value: "2" },
                      { label: "Initiated", value: "3" },
                    ]}
                  />
                </>
              ) : (
                <>
                  <p className="required text-textGray mt-2">Keyword</p>
                  <CommonInput
                    placeholder="Seacrh"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyWord(e.target.value)}
                    className="outline-none text-xs border mt-2 w-full  border-gray-200 focus:border-primary  "
                  />
                </>
              )}
            </div>
            {profiledetail.member_type !== "Retailer" && (
              <div className="w-full">
                <p className={`required text-textGray mt-2`}>
                  Select Member Type
                </p>
                <Select
                  showSearch
                  placeholder="Select member type"
                  value={memberTypeFilter}
                  onChange={(val) => setMemberTypeFilter(val)}
                  className="w-full mt-2"
                  options={memberOptions}
                  optionFilterProp="label"
                  filterOption={(input, option) => {
                    const label = option?.label?.toLowerCase() || "";
                    const mobile = option?.mobile?.toLowerCase() || "";

                    return (
                      label.includes(input.toLowerCase()) ||
                      mobile.includes(input.toLowerCase())
                    );
                  }}
                />
              </div>
            )}
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-between items-center mt-3">
            {/* {totalAmt === 0 ? (
              ""
            ) : (
              <p
                style={{ color: "white" }}
                className=" font-semibold flex justify-between gap-2 items-center p-2 rounded-md  hover:bg-primaryhover bg-primary border-none"
              >
                <p>Total Amount : ₹ {totalAmt}</p>
              </p>
            )} */}
            <div className="flex gap-3">
              <div className="bg-primary text-white px-4 py-2 rounded">
                Total ₹ {""}
                {amountData?.total_amount ?? "0"}
              </div>
              <div className="border border-green-500 text-green-600 px-4 py-2 rounded">
                Approved ₹ {""}
                {amountData?.approved_amount ?? "0"}
              </div>
              <div className="border border-red-500 text-red-600 px-4 py-2 rounded">
                Rejected ₹ {""}
                {amountData?.rejected_amount ?? "0"}
              </div>
              <div className="border border-orange-500 text-orange-600 px-4 py-2 rounded">
                Pending ₹ {""}
                {amountData?.pending_amount ?? "0"}
              </div>
              <div className="border border-yellow-500 text-yellow-600 px-4 py-2 rounded">
                Initiated ₹ {""}
                {amountData?.initiated_amount ?? "0"}
              </div>
            </div>
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[800px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>
      {openReceiptDrawer && (
        <ReportDrawer
          title={"Fund Request Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          data={result}
        />
      )}
      {openImageModal && (
        <Modal
          footer={null}
          open={openImageModal}
          onCancel={() => SetOpenImageModal(false)}
          title="Attachment"
        >
          <img className="h-[400px] w-full" src={attachment} />
        </Modal>
      )}
    </>
  );
};

export default FundRequestReport;
